export default {
  dynamics: '{{change}} edelliseen viikkoon verrattuna',
};
